import React, { useState, useEffect, useRef } from 'react';
import './formulario.css';
import API from "../../providers/api";
import { Card, CardBody, Col, Input, Button, Row, InputGroup, InputGroupText, CardHeader, CardTitle, CardText } from "reactstrap"
import { FaUser, FaPhone, FaEnvelope, FaMapMarked, FaAddressCard, FaCheckCircle, FaUserSecret, FaSignature } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import { alert } from '../../helpers/alert';
import ReCAPTCHA from 'react-google-recaptcha'
import moment from 'moment';
import customer_support from '../../assets/img/customer_support.jpg'
import energy_deregulation from '../../assets/img/energy_deregulation.jpg';
import solar_panel from '../../assets/img/solar_panel.jpg';
import banner_es from '../../assets/img/web-form-es.png';
import banner_en from '../../assets/img/web-form-en.png';
import { FaA } from 'react-icons/fa6';

const Formulario = () => {
    const recaptcha = useRef()
    const [lang, setLang] = useState('');
    const [nombrePersona, setNombrePersona] = useState('');
    const [apellidoPersona, setApellidoPersona] = useState('');
    const [telefonoPersona, setTelefonoPersona] = useState('');
    const [direccionPersona, setDireccionPersona] = useState('');
    const [listadoServicioPersona, setListadoServicioPersona] = useState([
        /* {
            imagen: solar_panel,
            titulo_es: 'PANEL SOLAR',
            titulo_en: 'SOLAR PANEL',
            descripcion_es: 'Comience a producir su propia electricidad y obtenga crédito en sus facturas al proporcionar a las empresas de servicios públicos la energía que usted produce.',
            descripcion_en: 'Start producing your own Electricity and get credit on your bills by providing the Utilities with the energy you produce.',
        }, */
        {
            imagen: energy_deregulation,
            titulo_es: 'DESREGULACIÓN ENERGÉTICA',
            titulo_en: 'ENERGY DEREGULATION',
            descripcion_es: 'Si vive en un mercado desregulado, aproveche las opciones disponibles. Haga clic a continuación para ver las ofertas vigentes.',
            descripcion_en: 'If you live in a deregulated market, take advantage of the choices that are available to you. Click below to see current offers.',
        },
        {
            imagen: customer_support,
            titulo_es: 'SERVICIO AL CLIENTE',
            titulo_en: 'CUSTOMER SERVICE',
            descripcion_es: 'Nuestro objetivo es permitirle ahorrar una cantidad sustancial en los bienes y servicios que necesita.',
            descripcion_en: 'Our goal is to enable you to save a substantial amount on your necessary goods and services.',
        }
    ]);
    const [servicioPersona, setServicioPersona] = useState('');
    const [indexServicio, setIndexServicio] = useState('');
    const [correoPersona, setCorreoPersona] = useState('');
    const [correctEmail, setCorrectEmail] = useState(false);
    const [opcionEstado, setOpcionEstado] = useState('-');
    const [zipCode, setZipCode] = useState('-');
    const [comentario, setComentario] = useState('-');
    const [aceptoTerminos, setAceptoTerminos] = useState(false);
    const [autorizacionEmail, setAutorizacionEmail] = useState(false);

    const [cargaEnviaForm, setCargaEnviaForm] = useState(true);

    useEffect(() => {
        // Obtiene la cadena de consulta de la URL
        const urlParams = new URLSearchParams(window.location.search);
        setLang(urlParams.get('lang'));
        limpiarCampos()
    }, [])


    const limpiarCampos = () => {
        setNombrePersona('')
        setApellidoPersona('')
        setTelefonoPersona('')
        setZipCode('')
        setComentario('-')
        setOpcionEstado('-')
        setDireccionPersona('')
        setAceptoTerminos(false)
        setAutorizacionEmail(false)
        setCorreoPersona('')
        setServicioPersona('')
    }

    const enviarForm = () => {
        if(lang == '')
            return alert("Advertencia","Debe seleccionar un idioma", "warning", "Cerrar")
        if(nombrePersona == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe ingresar un nombre", "warning", "Cerrar")
            else
                return alert("Advertencia","Please enter a name", "warning", "Close")
        }
        if(apellidoPersona == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe ingresar un apellido", "warning", "Cerrar")
            else
                return alert("Advertencia","Please enter a last name", "warning", "Close")
        }
        if(correoPersona == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe ingresar un correo electrónico", "warning", "Cerrar")
            else
                return alert("Advertencia","Please enter an email", "warning", "Close")
        }
        if(telefonoPersona == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe ingresar un teléfono", "warning", "Cerrar")
            else
                return alert("Advertencia","Please enter a phone number", "warning", "Close")
        }
        if(direccionPersona == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe ingresar una dirección", "warning", "Cerrar")
            else
                return alert("Advertencia","Please enter an address", "warning", "Close")
        }
        if(opcionEstado == '-'){
            if(lang == 'es')
                return alert("Advertencia","Debe seleccionar un estado", "warning", "Cerrar")
            else
                return alert("Advertencia","Please select a state", "warning", "Close")
        }
        if(zipCode == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe ingresar un código postal", "warning", "Cerrar")
            else
                return alert("Advertencia","Please enter a zip code", "warning", "Close")
        }
        if(servicioPersona == ''){
            if(lang == 'es')
                return alert("Advertencia","Debe seleccionar un servicio", "warning", "Cerrar")
            else
                return alert("Advertencia","Please select a service", "warning", "Close")
        }
        if(comentario == '')
            setComentario('-')
        if(aceptoTerminos == false){
            if(lang == 'es')
                return alert("Advertencia","Debe aceptar la privacidad", "warning", "Cerrar")
            else
                return alert("Advertencia","Please accept the privacy", "warning", "Close")
        }
        console.log(recaptcha, "recaptcha")
        const captchaValue = recaptcha?.current.getValue()
        if (!captchaValue) {
            if(lang == 'es')
                return alert("Advertencia","Debe completar el captcha", "warning", "Cerrar")
            else
                return alert("Advertencia","Please complete the captcha", "warning", "Close")
        } else {
            setCargaEnviaForm(false)
            API.validarRecaptcha(captchaValue)
            .then(data => data.json())
            .then(dataJsonR => {
                if(dataJsonR.response.success == true){
                    API.guardarFormWeb(nombrePersona, apellidoPersona, telefonoPersona, correoPersona, zipCode, comentario, opcionEstado, 'ticservice.org', direccionPersona, servicioPersona, lang)
                    .then(data => data.json())
                    .then(dataJson => {
                        if (dataJson.success == true) {
                            if(lang == 'es')
                                alert("Éxito",'Mensaje enviado correctamente', "success", "Cerrar")
                            else
                                alert("Success",'Message send successfully', "success", "Close")
                        }else{
                            if(lang == 'es')
                                alert("Advertencia",'Error al enviar el mensaje', "warning", "Cerrar")
                            else
                                alert("Advertence",'Error sending message', "warning", "Close")
                        }
                        setCargaEnviaForm(true)
                        limpiarCampos()
                    })
                    .catch((e) => {
                        console.log("Error =>", e)
                        setCargaEnviaForm(true)
                    })
                }else{
                    setCargaEnviaForm(true)
                    alert("Advertencia",'Ups! Algo ha salido mal...', "warning", "Cerrar")
                }
            })
            .catch((e) => {
                console.log("Error =>", e)
                setCargaEnviaForm(true)
            })
        }
    }

    const onchangeServicio = (item, index) => {
        setServicioPersona(lang == 'es' ? item.titulo_es : item.titulo_en)
        setIndexServicio(index)
    }

    const validateEmail = (email) => {
        let isValidEmail = /\S+@\S+\.\S+/.test(email);
        if (!isValidEmail) {
            setCorrectEmail(false);
        } else {
            setCorrectEmail(true);
        }
    }

    return (
        <>
        <div>
            <div className='container'>
                <div style={{borderRadius:'15px'}}>
                    <Card style={{border:'1px solid #1D2E4C',borderRadius:'15px'}}>
                        <div style={{backgroundColor:'#1D2E4C'}}>
                            <img src={lang == 'es' ? banner_es : banner_en} alt={lang == 'es' ? "FORMULARIO WEB" : "FORM WEB"} style={{width:'100%',maxWidth:'1320px'}} />
                        </div>
                        <CardBody style={{background: 'aliceblue'}}>
                            <Row>
                                <Col lg='12' md='12' style={{paddingRight:'10px'}}>
                                    <Row className='mt-4 text-center'>
                                        <Col lg="12">
                                            <h1 style={{fontFamily:'"Poppins", cursive', fontSize:'1.5rem'}}>{lang == 'es' ? "Información de Registro" : "Registration Info"}</h1>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg='6' md='12'>
                                            <label style={nombrePersona == '' ? {color:'red'} : {}}>{lang == 'es' ? "Nombres" : "Name"} {nombrePersona == '' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaUser size={20} />
                                                    </InputGroupText>
                                                </div>
                                                <Input className='input' value={nombrePersona} onChange={e => setNombrePersona(e.target.value)} />
                                            </InputGroup>
                                        </Col>
                                        <Col lg='6' md='12'>
                                            <label style={apellidoPersona == '' ? {color:'red'} : {}}>{lang == 'es' ? "Apellidos" : "Last Name"} {apellidoPersona == '' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaUser size={20} />
                                                    </InputGroupText>
                                                </div>
                                                <Input className='input' value={apellidoPersona} onChange={e => setApellidoPersona(e.target.value)} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg='12' md='12'>
                                            <label style={correoPersona == '' ? {color:'red'} : {}}>{lang == 'es' ? "Correo electrónico" : "Email"} {correoPersona == '' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaEnvelope size={20} />
                                                    </InputGroupText>
                                                </div>
                                                {
                                                    (correctEmail === false && correoPersona !== "") && <label style={{ color: "red" }}>, format is invalid</label>
                                                }
                                                <Input className='input' value={correoPersona} onChange={event => {validateEmail(event.target.value);setCorreoPersona(event.target.value)}} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg='6' md='12'>
                                            <label style={telefonoPersona == '' ? {color:'red'} : {}}>{lang == 'es' ? "Teléfono de contacto" : "Contact Phone"} {telefonoPersona == '' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaPhone size={20} />
                                                    </InputGroupText>
                                                </div>
                                                {
                                                    (correctEmail === false && correoPersona !== "") && <label style={{ color: "red" }}>, format is invalid</label>
                                                }
                                                <Input type="number" className='input' value={telefonoPersona} onChange={(event) => {
                                                    let numbers = event.target.value.replace(/[^0-9]/g, "");

                                                    if (numbers.length > 10) {
                                                        let slicePhone = telefonoPersona.slice(0, 10)
                                                        setTelefonoPersona(slicePhone);
                                                    } else {
                                                        setTelefonoPersona(numbers);
                                                    }

                                                }} />
                                            </InputGroup>
                                        </Col>
                                        <Col lg='6' md='12'>
                                            <label style={direccionPersona == '' ? {color:'red'} : {}}>{lang == 'es' ? "Dirección de contacto" : "Contact Address"} {direccionPersona == '' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaAddressCard size={20} />
                                                    </InputGroupText>
                                                </div>
                                                <Input className='input' value={direccionPersona} onChange={e => setDireccionPersona(e.target.value)} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <label style={opcionEstado == '-' ? {color:'red'} : {}}>{lang == 'es' ? "Estado" : "State"} {opcionEstado == '-' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaMapMarked size={20} />
                                                    </InputGroupText>
                                                </div>
                                                <Input className='input' type='select' value={opcionEstado} onChange={e => setOpcionEstado(e.target.value)}>
                                                    <option value="-">Seleccione...</option>
                                                    <option value="Alabama (AL)">Alabama (AL)</option>
                                                    <option value="Alaska (AK)">Alaska (AK)</option>
                                                    <option value="Arizona (AZ)">Arizona (AZ)</option>
                                                    <option value="Arkansas (AR)">Arkansas (AR)</option>
                                                    <option value="California (CA)">California (CA)</option>
                                                    <option value="Carolina del Norte (NC)">Carolina del Norte (NC)</option>
                                                    <option value="Carolina del Sur (SC)">Carolina del Sur (SC)</option>
                                                    <option value="Colorado (CO)">Colorado (CO)</option>
                                                    <option value="Connecticut (CT)">Connecticut (CT)</option>
                                                    <option value="Dakota del Norte (ND)">Dakota del Norte (ND)</option>
                                                    <option value="Dakota del Sur (SD)">Dakota del Sur (SD)</option>
                                                    <option value="Delaware (DE)">Delaware (DE)</option>
                                                    <option value="Florida (FL)">Florida (FL)</option>
                                                    <option value="Georgia (GA)">Georgia (GA)</option>
                                                    <option value="Hawái (HI)">Hawái (HI)</option>
                                                    <option value="Idaho (ID)">Idaho (ID)</option>
                                                    <option value="Illinois (IL)">Illinois (IL)</option>
                                                    <option value="Indiana (IN)">Indiana (IN)</option>
                                                    <option value="Iowa (IA)">Iowa (IA)</option>
                                                    <option value="Kansas (KS)">Kansas (KS)</option>
                                                    <option value="Kentucky (KY)">Kentucky (KY)</option>
                                                    <option value="Luisiana (LA)">Luisiana (LA)</option>
                                                    <option value="Maine (ME)">Maine (ME)</option>
                                                    <option value="Maryland (MD)">Maryland (MD)</option>
                                                    <option value="Massachusetts (MA)">Massachusetts (MA)</option>
                                                    <option value="Míchigan (MI)">Míchigan (MI)</option>
                                                    <option value="Minnesota (MN)">Minnesota (MN)</option>
                                                    <option value="Misisipi (MS)">Misisipi (MS)</option>
                                                    <option value="Misuri (MO)">Misuri (MO)</option>
                                                    <option value="Montana (MT)">Montana (MT)</option>
                                                    <option value="Nebraska (NE)">Nebraska (NE)</option>
                                                    <option value="Nevada (NV)">Nevada (NV)</option>
                                                    <option value="Nueva Jersey (NJ)">Nueva Jersey (NJ)</option>
                                                    <option value="Nueva York (NY)">Nueva York (NY)</option>
                                                    <option value="Nuevo Hampshire (NH)">Nuevo Hampshire (NH)</option>
                                                    <option value="Nuevo México (NM)">Nuevo México (NM)</option>
                                                    <option value="Ohio (OH)">Ohio (OH)</option>
                                                    <option value="Oklahoma (OK)">Oklahoma (OK)</option>
                                                    <option value="Oregón (OR)">Oregón (OR)</option>
                                                    <option value="Pensilvania (PA)">Pensilvania (PA)</option>
                                                    <option value="Rhode Island (RI)">Rhode Island (RI)</option>
                                                    <option value="Tennessee (TN)">Tennessee (TN)</option>
                                                    <option value="Texas (TX)">Texas (TX)</option>
                                                    <option value="Utah (UT)">Utah (UT)</option>
                                                    <option value="Vermont (VT)">Vermont (VT)</option>
                                                    <option value="Virginia (VA)">Virginia (VA)</option>
                                                    <option value="Virginia Occidental (WV)">Virginia Occidental (WV)</option>
                                                    <option value="Washington (WA)">Washington (WA)</option>
                                                    <option value="Wisconsin (WI)">Wisconsin (WI)</option>
                                                    <option value="Wyoming (WY)">Wyoming (WY)</option>
                                                </Input>
                                            </InputGroup>
                                        </Col>
                                        <Col lg='6' md='12'>
                                            <label style={zipCode == '' ? {color:'red'} : {}}>{lang == 'es' ? "Código postal" : "Zip Code"} {zipCode == '' ? '*' : ''}</label>
                                            <InputGroup>
                                                <div addonType="append">
                                                    <InputGroupText style={{padding:'0.575rem .75rem',color:'#858686'}}>
                                                        <FaMapMarked size={20} />
                                                    </InputGroupText>
                                                </div>
                                                <Input type="number" className='input' value={zipCode} onChange={e => setZipCode(e.target.value)} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg='12' md='12'>
                                            <label>{lang == 'es' ? "Comentario adicional" : "Additional Comment"}</label>
                                            <Input className='input' type='textarea' value={comentario} onChange={e => setComentario(e.target.value)} />
                                        </Col>
                                    </Row>

                                    <Row className='mt-4'>
                                        <Col lg='12' md='12'>
                                            <label style={servicioPersona == '' ? {color:'red'} : {}}>{lang == 'es' ? "Servicios" : "Services"}</label>
                                            <Row>
                                            {listadoServicioPersona.map((item, index) => (
                                                <Col lg="6" key={index}>
                                                    <Card className="cards" style={servicioPersona != '' && indexServicio == index ? {border:'3px solid #28C76F', borderRadius:'5px', padding:'10px'} : {border:'1px solid #ccc', borderRadius:'5px', padding:'10px'}}>
                                                        <img className="card-img-top" src={item.imagen} alt="logo" />
                                                        <CardBody>
                                                            <CardTitle style={{fontWeight:'bold',textAlign:'center'}}>{lang == 'es' ? item.titulo_es : item.titulo_en}</CardTitle>
                                                            <CardText style={{textAlign:'justify'}}>{lang == 'es' ? item.descripcion_es : item.descripcion_en}</CardText>
                                                        </CardBody>
                                                        <CardBody className='d-grid gap-2'>
                                                            {
                                                                servicioPersona != '' && indexServicio == index ?
                                                                <Button className='mt-2' color="success" onClick={() => onchangeServicio(item, index)}>{lang == 'es' ? "Seleccionado" : "Selected"} <FaCheckCircle /></Button>
                                                                : <Button className='mt-2' color="primary" onClick={() => onchangeServicio(item, index)}>{lang == 'es' ? "Seleccionar" : "Select"}</Button>
                                                            }
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className='mt-4'>
                                        <Col lg="12">
                                            <label style={aceptoTerminos == false ? {color:'red'} : {}}>{lang == 'es' ? "Privacidad" : "Privacy"} {aceptoTerminos == false ? '*' : ''}<FaUserSecret /></label><br/>
                                            <p style={{textAlign:'justify'}}><Input type="checkbox" checked={aceptoTerminos} onChange={e => setAceptoTerminos(e.target.checked)} /> {" "} {lang == 'es' ? "Al proporcionar un número de teléfono y enviar este formulario, usted acepta que lo contactemos por llamada telefónica. Pueden aplicarse tarifas por mensajes y datos. Puede responder STOP para cancelar la suscripción a más mensajes." : "By providing a phone number and submitting this form, you agree to contact us by phone call. You may be charged for messages and data. You can respond STOP to cancel your subscription to more messages."} </p>
                                        </Col>
                                    </Row>

                                    <Row className='mt-4'>
                                        <Col lg="12">
                                            <label>{lang == 'es' ? "Autorización" : "Authorization"}{" "}<FaSignature /></label><br/>
                                            <p style={{textAlign:'justify'}}><Input type="checkbox" checked={autorizacionEmail} onChange={e => setAutorizacionEmail(e.target.checked)} /> {" "} {lang == 'es' ? "Autorizo el envio de actualizaciones por correo electrónico." : "I authorize the sending of updates by email."}</p>
                                        </Col>
                                    </Row>

                                    <Row className='mt-4'>
                                        <Col></Col>
                                        <Col className='text-center'>
                                            <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
                                        </Col>
                                        <Col></Col>
                                    </Row>

                                    <div className='row mt-4'>
                                        <div className='col-lg-2'></div>
                                        <div className='col-lg-8'>
                                            {
                                                cargaEnviaForm ?
                                                    <Button color="success" style={{width:'100%',borderRadius:'15px'}} onClick={() => enviarForm()}>{lang == 'es' ? "Enviar formulario" : "Send Form"}</Button>
                                                    : <Button color="success" style={{width:'100%',borderRadius:'15px'}} disabled={true}>{lang == 'es' ? "Enviando..." : "Sending..."}</Button>
                                            }
                                        </div>
                                        <div className='col-lg-2'></div>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    </>
    );
}

export default Formulario;